// extracted by mini-css-extract-plugin
module.exports = {"container":"vS3XiR"};